import React from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import { useStaffingSelector } from 'redux/selectors/staffing/staffingSelectors';
import { openStaffingChecklistModal } from 'redux/actions/staffingActions';
import StaffingChecklistForm from 'components/Forms/Staffing/StaffingChecklistForm';

const useStyles = makeStyles(theme => ({
  paperWidthSm: {
    maxWidth: 700,
  },
  contentRoot: {
    padding: theme.spacing(5),
  },
  dialogHeader: {
    position: 'relative',
    maxWidth: 700,
    width: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogHeaderRoot: {
    padding: '24px 8px',
  },
  dialogHeaderTitle: {
    fontSize: 16,
    fontWeight: 500,
  },
  cancelButton: {
    position: 'absolute',
    right: theme.spacing(1),
  },
}));

const StaffingChecklistDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isOpenStaffingChecklistModal, staffingChecklistCategory } = useStaffingSelector();

  const closeDialog = () => {
    dispatch(openStaffingChecklistModal(false));
  };

  return (
    <div>
      <Dialog
        open={isOpenStaffingChecklistModal}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        classes={{
          paperWidthSm: classes.paperWidthSm,
        }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          disableTypography
          className={classes.dialogHeader}
          classes={{ root: classes.dialogHeaderRoot }}
        >
          <Typography className={classes.dialogHeaderTitle}>
            {staffingChecklistCategory} Checklist
          </Typography>
          <IconButton className={classes.cancelButton} aria-label="close" onClick={closeDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className={classes.contentRoot}>
          <StaffingChecklistForm closeDialog={closeDialog} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default StaffingChecklistDialog;
